{
  "name": "ng-three-template",
  "version": "16.2.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build": "ng build -c development",
    "build:prod": "ng build -c production",
    "build:preview": "ng build -c preview",
    "build:both": "npm run build && npm run build:prod",
    "archive": "zip -r archive.zip . -x 'node_modules/*' '.angular/*' '.vscode/*'",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~19.2.21",
    "@angular/common": "~19.2.21",
    "@angular/compiler": "~19.2.21",
    "@angular/core": "~19.2.21",
    "@angular/forms": "~19.2.21",
    "@angular/platform-browser": "~19.2.21",
    "@angular/platform-browser-dynamic": "~19.2.21",
    "@angular/router": "~19.2.21",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@pixi/unsafe-eval": "^7.4.3",
    "@tweenjs/tween.js": "^23.1.1",
    "angular-google-tag-manager": "1.11.0",
    "bootstrap": "~4.6.0",
    "fontfaceobserver": "^2.3.0",
    "ngx-device-detector": "9.0.0",
    "ngx-pagination": "^6.0.3",
    "pixi-viewport": "5.0.2",
    "pixi.js": "^7.4.0",
    "rxjs": "~7.8.0",
    "stats.js": "^0.17.0",
    "swiper": "^8.4.7",
    "tslib": "^2.4.0",
    "tweakpane": "^4.0.1",
    "xmlbuilder": "^15.1.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^19.2.25",
    "@angular/cli": "~19.2.25",
    "@angular/compiler-cli": "~19.2.21",
    "@angular/language-service": "~19.2.21",
    "@tweakpane/core": "^2.0.1",
    "@types/jasmine": "~4.3.5",
    "@types/node": "^18.17.5",
    "@types/three": "^0.155.0",
    "@types/webgl2": "0.0.7",
    "husky": "^8.0.3",
    "jasmine-core": "~4.6.0",
    "lint-staged": "^15.0.2",
    "prettier": "^2.0.0",
    "pretty-quick": "^3.1.3",
    "typescript": "~5.8.3"
  },
  "lint-staged": {
    "**/*": "prettier --write --ignore-unknown"
  },
  "overrides": {
    "qs": ">=6.14.1",
    "glob": ">=12.0.0",
    "tar": ">=7.5.16",
    "pacote": "^21.5.1",
    "vite": "^6.4.3",
    "micromatch": {
      "picomatch": ">=2.3.2"
    },
    "pretty-quick": {
      "picomatch": ">=3.0.2"
    }
  }
}